module.exports = __webpack_public_path__ + "img/khong_chung_minh_thu_nhap.32467c49.svg";